import { default as format } from 'date-fns/format'

export default (date) => {
  if (date) {
    return format(new Date(date), 'MMMM yyyy')
  }
  return ''
}
